import { createContext } from 'react';

type AccountingTableContextValue = {
  columnCount: number;
};

const AccountingTableContext = createContext<AccountingTableContextValue>({
  columnCount: 1,
});

export default AccountingTableContext;
